import React, { useContext } from 'react';
import { MdOutlineAutorenew, MdOutlineLocalShipping } from 'react-icons/md';
import { useFormContext } from 'react-hook-form';

import {
  NonCommerceInfoContext,
  ProductContainerContext,
} from '@repo/contexts';
import { Button } from '../../shadcn/Button';
import { Label } from '../../shadcn/Label';
import { RadioGroup } from '../../shadcn/RadioGroup';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../shadcn/Select';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

const ProductSellingPlans = () => {
  const { clearErrors, formState, setValue, getValues } = useFormContext();
  const { tt } = useUiComponentsInternationalContext();

  // @ts-expect-error until context is converted to TS...KA
  const { isNonCommerce } = useContext(NonCommerceInfoContext);
  const {
    sellingPlanGroups,
    setSelectedSellingPlan,
    setSubscribed,
    subscribed,
  } = useContext(ProductContainerContext) as any;

  if (isNonCommerce) return null;
  if (sellingPlanGroups === undefined || sellingPlanGroups.length === 0)
    return null;

  return (
    <div className="flex flex-col w-full gap-6">
      <span className="bg-brand-aa-white text-white px-4 py-2 rounded-lg w-full">
        {tt(s => s.productOptionsComponent.selectAutoshipLabel, {
          autoshipLabel: (
            <span className="font-bold">
              {tt(s => s.productOptionsComponent.autoshipLabel)}
            </span>
          ),
        })}{' '}
        <span className="font-bold">
          {tt(s => s.productOptionsComponent.percentageDiscountPurchaseLabel, {
            percentageDiscount: sellingPlanGroups[0].percentageDiscount,
          })}
        </span>{' '}
        {tt(s => s.productOptionsComponent.withDeliveryLabel)}
      </span>
      <RadioGroup className="flex w-full gap-3">
        <Button
          aria-label={tt(
            s => s.productOptionsComponent.setToSubscriptionAriaLabel
          )}
          className="flex-col whitespace-normal gap-1"
          onClick={() => setSubscribed(true)}
          size="auto"
          variant={subscribed ? 'secondary' : 'outline'}
        >
          <MdOutlineAutorenew
            className={`h-6 w-6 ${
              subscribed ? 'text-secondary-foreground-aa' : 'text-foreground'
            }`}
          />
          <div className="flex flex-col">
            <span className="text-lg font-bold">Autoship</span>
            <span
              className={`text-xs ${
                subscribed ? 'text-secondary-foreground-aa' : 'text-foreground'
              }`}
            >
              {tt(s => s.productOptionsComponent.saveLabel, {
                percentageDiscount: sellingPlanGroups[0].percentageDiscount,
              })}
            </span>
          </div>
        </Button>
        <Button
          aria-label={tt(
            s => s.productOptionsComponent.setOneTimeShipmentAriaLabel
          )}
          className="flex-col whitespace-normal gap-1"
          onClick={() => setSubscribed(false)}
          size="auto"
          variant={!subscribed ? 'secondary' : 'outline'}
        >
          <MdOutlineLocalShipping
            className={`h-6 w-6 ${
              !subscribed ? 'text-secondary-foreground-aa' : 'text-foreground'
            }`}
          />
          <span className="font-bold text-lg">One-Time Shipment</span>
        </Button>
      </RadioGroup>
      {subscribed && (
        <form>
          <div className="flex flex-col items-start gap-2">
            <Label
              className="text-foreground font-bold"
              htmlFor="delivery-frequency-select"
            >
              {tt(s => s.productOptionsComponent.deliveryFrequencyLabel)}
            </Label>
            <Select
              onValueChange={value => {
                const plan = sellingPlanGroups?.find(p => p.id === value);
                setSelectedSellingPlan(plan);
                setValue('sellingPlanId', value);
                clearErrors('sellingPlanId');
              }}
              value={getValues('sellingPlanId')}
            >
              <SelectTrigger
                aria-label={tt(
                  s =>
                    s.productOptionsComponent
                      .deliveryFrequencyDescriptionAriaLabel
                )}
                id="delivery-frequency-select"
              >
                <SelectValue
                  placeholder={tt(
                    s => s.productOptionsComponent.pleaseSelectLabel
                  )}
                />
              </SelectTrigger>
              <SelectContent>
                {sellingPlanGroups.map(plan => (
                  <SelectItem key={plan.id} value={plan.id}>
                    {plan.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {formState.errors && (
              <span className="text-sm text-destructive">
                {formState.errors.sellingPlanId?.message?.toString()}
              </span>
            )}
          </div>
        </form>
      )}
    </div>
  );
};

export default ProductSellingPlans;
